import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const exportarPedido = async (params) => {
  const {data, status} = await api.post(
    `/drp/pedidos/exportacoes/winthor`, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.resposta;
  }

  logout();
}
